import { render, staticRenderFns } from "./ReportDetails.vue?vue&type=template&id=396513a4&scoped=true&"
import script from "./ReportDetails.vue?vue&type=script&lang=js&"
export * from "./ReportDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396513a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('396513a4')) {
      api.createRecord('396513a4', component.options)
    } else {
      api.reload('396513a4', component.options)
    }
    module.hot.accept("./ReportDetails.vue?vue&type=template&id=396513a4&scoped=true&", function () {
      api.rerender('396513a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ReportDetails.vue"
export default component.exports